export async function callRPC(method: HttpMethod, url: string, body?: any) {
  return await fetch(`/api/Rpc/${url}`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      method: method ?? "GET",
      body: JSON.stringify(body ?? {}),
    }),
  })
    .then((response) => response.json())
    .then((response) => response.data);
}

export async function callRPCGetResponse(method: HttpMethod, url: string, body?: any) {
  return await fetch(`/api/Rpc/${url}`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      method: method ?? "GET",
      body: JSON.stringify(body ?? {}),
    }),
  })
    .then((response) => response.json())
    .then((response) => response);
}

export enum HttpMethod {
  GET = "GET",
  POST = "POST",
}
